import React from 'react'
import { AppBasicTable } from "@components"
import { priceColumn } from "Pages/AnalyzersV2/@components/CategoriesTable/columns"
import { isAnalyzerLoading } from "Pages/AnalyzersV2/@signals"
import { Skeleton } from "@mui/material"
import AnalyzerHeaderTable from "Pages/AnalyzersV2/@components/CategoriesTable/Header"
import AnalyzerCategoriesTableToolbar from './Toolbar'


export default function AnalyzerCategoriesTable({ xList, tableData, evolutionData, setFullScreen, isFullScreen, tableSx = {} }) {
    let rowIndex = 0
    if (isAnalyzerLoading.value) return <Skeleton variant="rectangular" height={400}/>

    if (!tableData?.length) return null

    return <AppBasicTable
        data={tableData}
        Components={{
            Title: () => <AnalyzerCategoriesTableToolbar setFullScreen={setFullScreen} isFullScreen={isFullScreen} />,
        }}
        columns={xList?.map(column => priceColumn(column))}
        headers={[xList?.map(item => ({ render: () => <AnalyzerHeaderTable key={item} label={item} {...evolutionData}/> }))]}
        setHeaderCellProps={() => ({
            sx: {
                p: .5,
                backgroundColor: 'primary.main',
            }
        })}
        setBodyCellProps={(_, row, idx, rowIdx) => {
            if (rowIdx === 0) {
                rowIndex++
            }
            return {
                sx: {
                    backgroundColor: rowIdx === 0 && (rowIndex % 2 !== 0 ? "background.grey" : "background.lightGrey"),
                }
            }
        }}
        sx={{
            padding: 0,
            '& td': {
                padding: 0,
                '& div': {
                    padding: 0,
                    height: '100%',
                },
            },
            ...(tableSx.sx || {})
        }}
    />

}